import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0.75),
  borderColor: (p) => p.palette.grey[300],
  borderStyle: 'solid',
  borderWidth: '1px',
  padding: (p) => p.spacing(1),
};

export const divider: SxStyle = {
  my: 0.5,
};
